export default {
  showBackgroundImage: false,
  border: true,
  rounded: '@theme:card.rounded',
  fontSize: '3',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'between',
  fareBodyItem: {
    paddingLeft: '2',
    paddingRight: '2',
    paddingBottom: '2',
  },
  fareItemBackgroundImage: {
    rounded: '@theme:card.rounded',
  },
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: true,
    showOriginLabel: true,
    showDestinationLabel: true,
    showSeparator: false,
    showLineSeparator: true,
    fontSize: '3',
    textTransform: 'uppercase',
    destinationStyles: {
      fontSize: '4',
    },
    originLabelStyles: {
      paddingRight: '1',
      fontWeight: 'light',
    },
    destinationLabelStyles: {
      paddingRight: '1',
      fontWeight: 'light',
    },
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    showPriceDisclaimer: false,
    paddingTop: '3',
    textAlign: 'left',
    style: { lineHeight: '1' },
    pricePromoStyles: {
      fontWeight: 'light',
      textTransform: 'uppercase',
    },
    currencyStyles: {
      fontSize: '5',
      marginHeight: '2px',
    },
  },
  fareItemLastSeen: {
    dateStyles: {
      fontWeight: 'light',
    },
  },
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
    departureText: 'cmp-label--departure-date-colon',
    fontWeight: 'light',
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: true,
    showReturnDate: true,
    returnText: 'cmp-label--return-date-colon',
    fontWeight: 'light',
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
};
